"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeDeliveryAddressSelection = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _addressFormContext = require("../../contexts/addressFormContext");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _Loading = require("../Loading");
var _CourierBoxSkeleton = require("../Skeleton/CourierBoxSkeleton");
var _Suggestions = require("../Suggestions");
var _useDeliverySuggestions = require("../Suggestions/useDeliverySuggestions");
var _shared = require("../shared");
var _ConfirmDeleteAddressDialog = require("./ConfirmDeleteAddressDialog");
var _NewAddress = require("./NewAddress");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const CourierSelectionFlat = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../CourierSelection/CourierSelectionFlat'))));

/**
 * Displays current state of home delivery addresses.
 *
 * The 1st page of address suggestions must be loaded first to check if any address is available.
 * Not having selected item doesn't mean that no addresses are available, just that user
 * didn't select anything yet (or previously-selected address was deleted).
 *
 * When no addresses are available, inline address form should be automatically displayed.
 * When user cancels the form action, add address button should be displayed.
 *
 * For available addresses, a list with SelectableCard components should be displayed, last used address selected by default.
 */
const HomeDeliveryAddressSelection = ({
  courierSelectionProps,
  isAddHomeDeliveryAddressAllowed,
  isDeliveryOptionsLoading,
  isSuggestionAvailable,
  ...props
}) => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    addressSectionRef,
    confirmDeleteAddressDialogProps,
    isConfirmDeleteAddressDialogOpen
  } = (0, _addressFormContext.useAddressForm)();
  const {
    suggestionsProps
  } = (0, _useDeliverySuggestions.useDeliverySuggestions)(props);
  const isCourierSelection = props.selectedItemHome?.addressId !== undefined;
  if (isDeliveryOptionsLoading) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_shared.FlatLayoutWrapper, {
      ref: addressSectionRef,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h6",
        children: formatMessage('shippingAddress')
      }), isAddHomeDeliveryAddressAllowed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewAddress.NewAddress, {
        isDeliveryOptionsLoading: isDeliveryOptionsLoading,
        isSelectedDeliveryLoading: props.isSelectedDeliveryLoading,
        isSuggestionAvailable: isSuggestionAvailable,
        ...getTestIdProps(_models.TestId.AddNewAddress)
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Suggestions.Suggestions, {
        ...suggestionsProps
      })]
    }), isCourierSelection ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CourierBoxSkeleton.CourierBoxSkeleton, {}),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CourierSelectionFlat, {
        ...courierSelectionProps
      })
    }) : null, isConfirmDeleteAddressDialogOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
        id: _models.TestId.DialogLoadingOverlayConfirmDeleteAddress
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfirmDeleteAddressDialog.ConfirmDeleteAddressDialog, {
        ...confirmDeleteAddressDialogProps
      })
    }) : null]
  });
};
exports.HomeDeliveryAddressSelection = HomeDeliveryAddressSelection;